module.exports = __webpack_public_path__ + "img/DSCN6042-compressor.ceea0ad3.jpg";